var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:'weui-form-preview__btn weui-form-preview__btn_' + _vm.type,attrs:{"href":"javascript:"},on:{"click":function($event){return _vm.click()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }